import React, { useContext } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Link from "next/link";
import getEmailUsUrl from "@/utils/getEmailUsUrl";
import { MonetateContext } from "../../../context/MonetateContext";
import ContactMethodsList from "./contact-methods-list/ContactMethodsList";
import styles from "./contact-methods.module.scss";

function ContactMethods({
  newDesign,
  fields,
  solutionId,
  location,
  contactDetails,
  subHeader,
  viewContactDetails,
  showGreyBackground,
  showEmailOption,
}) {
  const { liveChatProminenceExperiment } = useContext(MonetateContext);

  let sortedFields = fields;
  const isChatAvailable = fields.some(field => field.name === "chat");
  if (liveChatProminenceExperiment && isChatAvailable) {
    sortedFields = [...fields].sort((a, b) => (a.name === "chat") - (b.name === "chat")).reverse();
  }

  return (
    <div className={classnames(styles.cm, fields.length === 1 ? styles.oneItem : null)}>
      <div className={styles.cm__subheader}>
        {liveChatProminenceExperiment
          ? viewContactDetails
            ? "Choose how you’d like to contact us"
            : "Find the best way to contact us below."
          : subHeader}
      </div>
      <ContactMethodsList
        fields={sortedFields}
        newDesign={newDesign}
        solutionId={solutionId}
        location={location}
        contactDetails={contactDetails}
        isChatSupported
        showGreyBackground={showGreyBackground}
      />
      {contactDetails.email?.open && showEmailOption ? (
        liveChatProminenceExperiment ? (
          <p className={styles.cm__email}>
            For quick help, chat with us or call our team. If it’s not urgent,{" "}
            <Link href={getEmailUsUrl(location)}>email us</Link> – we’ll usually reply within 24 hours, though some
            queries may take a little longer to resolve.
          </p>
        ) : (
          <p className={styles.cm__email}>
            Please note: if you prefer to <Link href={getEmailUsUrl(location)}>email us</Link>, it may take up to 24
            hours for a response and longer for us to resolve your query. We recommend phone or chat for a quicker
            response and resolution.
          </p>
        )
      ) : null}
    </div>
  );
}

ContactMethods.propTypes = {
  newDesign: PropTypes.bool,
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      values: PropTypes.arrayOf(PropTypes.string),
    }),
  ),
  solutionId: PropTypes.string,
  location: PropTypes.string,
  contactDetails: PropTypes.shape({
    phone: PropTypes.objectOf(PropTypes.any).isRequired,
    chat: PropTypes.objectOf(PropTypes.any).isRequired,
    email: PropTypes.shape({
      open: PropTypes.bool,
    }),
  }),
  subHeader: PropTypes.string,
  viewContactDetails: PropTypes.bool,
  showGreyBackground: PropTypes.bool,
};

ContactMethods.defaultProps = {
  newDesign: false,
  fields: [],
  solutionId: null,
  location: undefined,
  contactDetails: {},
  subHeader: "If you still need help our Partners will try their best to help",
  viewContactDetails: false,
  showGreyBackground: false,
};

export default ContactMethods;
